export default __webpack_public_path__ + "static/media/setting.e60a0e17.svg";